
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 14 14"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.613 2.333a1.063 1.063 0 00-1.057 1.056v1.278H1.19A1.2 1.2 0 000 5.856v4.966a1.2 1.2 0 001.189 1.189H12.81A1.2 1.2 0 0014 10.822V5.856a1.2 1.2 0 00-1.189-1.189h-.366V3.384a1.063 1.063 0 00-1.057-1.056H8.836a1.063 1.063 0 00-1.058 1.056v1.278H6.223V3.384a1.063 1.063 0 00-1.058-1.056zm0 .776h2.552a.271.271 0 01.279.28v1.278H2.333V3.384a.271.271 0 01.28-.275zm6.222 0h2.552a.271.271 0 01.279.28v1.278H8.555V3.384a.271.271 0 01.28-.275zM1.189 5.444H12.81a.4.4 0 01.412.412v4.966a.4.4 0 01-.412.411H1.189a.4.4 0 01-.412-.411V5.856a.4.4 0 01.412-.412z"}})])
          )
        }
      }
    